import axios from "axios";

axios.interceptors.request.use(function (config) {
  config.headers["ClientId"] = sessionStorage.getItem("clientID")
  config.headers["UserId"] = sessionStorage.getItem("UserId")
  config.headers["UserType"] = sessionStorage.getItem("userType")

  // Only set Content-Type to application/json if it's not a FormData request
  // FormData needs to set its own Content-Type with boundary
  if (!(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json"
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  response.headers["ClientId"] = sessionStorage.getItem("token")
  return response;
}, function (error) {

  return Promise.reject(error);
});

export default axios;
